import React, { useState, useEffect } from "react";
import ShowImageModal from '../../modals/showImageModal'
import useEndpoints from "../../api/useEndpoints";
import CountDownTimer from "../countDownTimer";
import { FiPhoneCall } from "react-icons/fi"

export default function HistoryInfoCardDoing(props) {

    var [showImage, setShowImage] = useState(false)
    var endpoints = useEndpoints()

    var [showTimer, setShowTimer] = useState(props.item?.waitingTime != 0)

    return (
        <div>
            < div className="card text-end mb-2 rounded " >
                <div className="card-body">
                    <div className="d-flex justify-content-center">
                        <h5 className="ps-1 text-danger ">
                            {'در ساعت : '}{props.item?.callTime}{' روز : '}{props.item?.callDate}
                        </h5>
                        {props.item?.waitingTime == 0
                            ? <></> :
                            <div className="d-flex">
                                <h5 className="ps-1 text-secondary col-4"></h5>
                                <h5 className="iranSansBold text-warning"><CountDownTimer
                                    timer={props.item?.waitingTime}
                                    finished={() => { setShowTimer(false) }} /></h5>
                                <hr className="p-0 ms-2" />
                                <h5 className="pe-1 iranSansBold text-success">دقیقه</h5>

                            </div>
                        }
                    </div>
                    <hr className="p-0 m-2" />
                    <div className="d-flex">
                        <h5 className="ps-1 text-secondary col-4">مقصد : </h5>
                        <h5 className="iranSansBold">{props.item?.destinations}</h5>
                    </div>
                    <div className="d-flex">
                        <h5 className="ps-1 text-secondary col-4">کد پیگیری : </h5>
                        <h5 className="iranSansBold">{props.item?.tripCode}</h5>
                    </div>
                    <div className="d-flex">
                        <h5 className="ps-1 text-secondary col-4">پرداخت در  : </h5>
                        <h5 className="iranSansBold">{props.item?.payerStr}</h5>
                    </div>
                    <div className="d-flex">
                        <h5 className="ps-1 text-secondary col-4">نوع سرویس : </h5>
                        <h5 className="iranSansBold">{props.item?.serviceType}</h5>
                    </div>

                    <div className="d-flex">
                        <h5 className="ps-1 text-secondary col-4">هزینه سرویس : </h5>
                        <h5 className="iranSansBold">{props.item?.totalAmount}</h5>
                    </div>
                    <div className="d-flex">
                        <h5 className="ps-1 text-secondary col-4">نوع وسیله : </h5>
                        <h5 className="iranSansBold text-dark">{props.item?.vehicleType}</h5>
                    </div>
                    <div className="d-flex">
                        <h5 className="ps-1 text-secondary col-4">قاصد : </h5>
                        <h5 className="iranSansBold text-warning">{props.item?.driverCode}</h5>
                    </div>

                    {props.item?.driverMobile ?
                        <div className="d-flex">
                            <h5 className="ps-1 text-secondary col-4">تماس با قاصد : </h5>
                            <a href={"tel:" + props.item?.driverMobile}>
                                <h5 className="iranSansBold text-decoration-none"> <FiPhoneCall size={30} />{props.item?.driverMobile}</h5>
                            </a>

                        </div>
                        : <></>}

               
                    <div className="row">
                        {props.item?.odati == 1 ? <h6 className="d-flex bg-secondary col-2 rounded text-light m-1 p-2 justify-content-center">عودتی</h6> : <></>}
                        {props.item?.bigTark == 1 ? <h6 className="d-flex bg-secondary col-2 rounded text-light m-1 p-2 justify-content-center">ترک بزرگ</h6> : <></>}
                        {props.item?.garantee == 1 ? <h6 className="d-flex bg-secondary col-2 rounded text-light m-1 p-2 justify-content-center">بیمه</h6> : <></>}
                        {props.item?.hasBasket == 1 ? <h6 className="d-flex bg-secondary col-2 rounded text-light m-1 p-2 justify-content-center">صندوق</h6> : <></>}
                        {props.item?.bulkyLoad == 1 ? <h6 className="d-flex bg-secondary col-2 rounded text-light m-1 p-2 justify-content-center">بار حجیم</h6> : <></>}
                        {props.item?.returnOrigin == 1 ? <h6 className="d-flex bg-secondary col-3 rounded text-light m-1 p-2 justify-content-center">بازگشت به مبدا</h6> : <></>}

                    </div>
                    {props.item?.showCancelBtn ?
                        (<div className="d-flex align-items-center justify-content-center my-2 ">
                            <button className="btn btn-danger  text-light iranSansBold  rounded py-2 px-3 me-2 small-shadow"
                                onClick={props?.cancelService}>
                                لغو سرویس
                            </button>

                        </div>
                        ) : null
                    }
                    {props.item?.showInfoBtn ?
                        (<div className="d-flex align-items-center justify-content-center my-2 ">
                            <button className="btn btn-info text-light iranSansBold rounded py-2 px-3 me-2 small-shadow"
                                onClick={() => {
                                    setShowImage(true)
                                }}>
                                نمایش تصویر قاصد
                            </button>

                        </div>
                        ) : null
                    }
                </div>
            </div >
            <ShowImageModal show={showImage} src={endpoints.image + props.item?.driverPic} onClose={() => setShowImage(false)} />

        </div >

    )
}